import { z } from 'zod'

export type OwnerScheme = z.infer<typeof ownerScheme>

export const ownerScheme = z.object({
  firstName: z.string().min(1, { message: 'Meno je povinné.' }),
  lastName: z.string().min(1, { message: 'Priezvisko je povinné.' }),
  age: z.number().min(19, { message: 'Minimálny vek je 19 rokov.' }),
})
